import { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { fetchStores, setStore } from 'actions/stores';
import { removeAuthSession } from 'theme/utils';
import { clearStockLocationId } from '../../utils';

let _content = null;

const StoreSelection = (props) => {
  localStorage.setItem('storeLoggedIn', JSON.stringify(false));
  localStorage.setItem('staffLoggedIn', JSON.stringify(false));

  const { fetchStores, setStore, stores, pending } = props;
  const [query, setQuery] = useState('');
  const [isPending, setIsPending] = useState(true);
  const [showPopularStore, setShowPopularStore] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [popularStore, setPopularStore] = useState([]);
  const inputRef = useRef(null);

  useEffect(() => {
    fetchStores();
    setIsPending(pending);
    removeAuthSession();
  }, []);

  useEffect(() => {
    let mounted = false;

    if (!mounted) {
      clearStockLocationId();
    }
    return () => {
      mounted = true;
    };
  }, []);

  useEffect(() => {
    let shopResults = '';
    if (stores.length > 0) {
      shopResults = stores.filter(
        (shop) =>
          (Boolean(shop.remote_id) &&
            (shop.remote_id === query || shop.remote_id.includes(query))) ||
          shop.name.toLowerCase().includes(query) ||
          shop.name.toUpperCase().includes(query)
      );

      setSearchResults(shopResults);
      setPopularStore(JSON.parse(localStorage.getItem('popularStore')));

      let popularStoreRID =
        JSON.parse(localStorage.getItem('popularStore')) !== null &&
        JSON.parse(localStorage.getItem('popularStore')).remote_id;
      let sameDomainStore = stores.filter(
        (item) => item.remote_id === popularStoreRID
      );
      sameDomainStore.length > 0 && setShowPopularStore(true);
    }
  }, [query, stores]);

  const setStorage = (store) => {
    setStore(store);
    localStorage.setItem('popularStore', JSON.stringify(store));
    localStorage.setItem('usedStorage', JSON.stringify(store));
  };

  const cleanQuery = () => {
    setQuery('');
    inputRef.current.focus();
  };

  const handleInputChange = (event) => {
    setQuery(event.target.value);
  };

  return (
    _content &&
    _content({
      isPending,
      props,
      showPopularStore,
      searchResults,
      popularStore,
      query,
      inputRef,
      setStorage,
      cleanQuery,
      handleInputChange,
    })
  );
};

const mapStateToProps = (state) => ({
  stores: state.stores.stores,
  pending: state.stores.pending,
  error: state.stores.error,
  currentStore: state.stores.currentStore,
});

const mapDispatchToProps = {
  fetchStores,
  setStore,
};

export default function (content) {
  _content = content;
  return connect(mapStateToProps, mapDispatchToProps)(StoreSelection);
}



// WEBPACK FOOTER //
// ./src/_pageContainers/storeSelection/index.js